import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
// import { history } from 'umi';
import { Card, Row, Col, Bubble } from 'tea-component';
// import TipContext from '@home/components/TipContextComponents/TipContext';
import Loading from '@intelligence/components/Loading';
import TimeType from '@intelligence/components/TimeType';
import OverviewCard from '@intelligence/components/OverviewCard';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import useCalcHasEmptyMetric from '../../hooks/useCalcHasEmptyMetric';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
import { toDateTypeLy } from '@intelligence/utils/common';
import { MONTH } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { COMPETITOR_GUIDE_CLASSNAMES } from '@intelligence/components/UserGuide/Competitor';
import { DATASOURCE_NAME, DataSourceBubbleInfo } from '@intelligence/components/DataSourceComponents';
import { calcIsEmptyOverviewCard } from '../../../utils';

const StreamingContent = (props: any) => {
  const {
    loading,
    gameId,
    setActiveId,
    setActiveSegment,
    activeId,
    moduleName,
    conditionMarket,
    entityType,
    isOperateRegion,
    showNoDataMetricCard,
    setStreamingDataHasEmptyMetric,
    getStreamingCardData,
    streamingLoading,
    streamingDataList,
    streamingRankLoading: rankLoading,
  } = props;

  const { formatMessage, locale } = useIntlExtend();

  const [streamingType, setStreamingType] = useState(MONTH);

  useCalcHasEmptyMetric({
    executable: !(loading || streamingLoading),
    metrics: streamingDataList,
    setHasEmptyMetric: setStreamingDataHasEmptyMetric,
  });

  const onChangeTimeType = (value: any) => {
    setStreamingType(value);
    getStreamingCardData(toDateTypeLy[value]);
  };

  // const handleClickLearnMore = () => {
  //   history.push(`/intelligence/sourcesMetrics/metrics/IntelligenceMetrics?pageid=Stream%20Hatchet`);
  // };

  useEffect(() => {
    getStreamingCardData(toDateTypeLy[streamingType]);
  }, []);

  return (
    <Card className="dbi-performance-summary dbi-kpioverview-card">
      <Card.Body
        title={
          <div className="performance-felx">
            <Bubble
              content={
                <div>
                  <DataSourceBubbleInfo
                    comesFormDom={
                      <>
                        <img
                          className="platform-title-icon"
                          style={{
                            height: '20px',
                            width: '20px',
                            margin: '0 4px',
                            verticalAlign: 'middle',
                          }}
                          src={getDataSourceIcon('stream')}
                        />
                        {DATASOURCE_NAME.stream}
                        <div>{formatMessage({ id: 'dbi_combine_stream_tips1' })}</div>
                        <div>{formatMessage({ id: 'dbi_combine_stream_tips2' })}</div>
                        <div>{formatMessage({ id: 'dbi_combine_stream_tips3' })}</div>
                      </>
                    }
                    metricKey={'Hours Watched,Peak CCV,Airtime'}
                    dataSource={'Stream Hatchet'}
                    entityType={entityType}
                  />
                </div>
              }
            >
              <div className="performance-felx">
                <img src={getDataSourceIcon('stream')} className="dbi-pcGame-select-icon" style={{ height: '20px', width: '20px' }} />
              </div>
            </Bubble>
            {/* <img
              src={getDataSourceIcon('stream')}
              className="dbi-pcGame-select-icon"
            /> */}
            <span>{formatMessage({ id: 'dbi_combine_streaming' })}</span>
            {/* <TipContext
              placement="top"
              className="dbi-common-chart-info-icon"
              tipText={
                <>
                  <div>
                    {formatMessage({ id: 'dbi_combine_streaming_tips' })}{' '}
                    <span
                      onClick={handleClickLearnMore}
                      className="dbi-common-chart-link"
                    >
                      {formatMessage({ id: 'dbi_top_learn_more' })}
                    </span>
                  </div>
                </>
              }
            /> */}
          </div>
        }
      >
        <TimeType
          locale={locale}
          lightTheme={false}
          onConfirm={(val: any) => {
            onChangeTimeType(val);
          }}
          defaultValue={MONTH}
          value={streamingType || ''}
        />

        {/* eslint-disable-next-line no-nested-ternary */}
        {streamingLoading ? (
          <Loading content={formatMessage({ id: 'common_loading' })} style={{ height: 142, color: '#444' }} />
        ) : (
          <Row>
            {streamingDataList?.map((item: any, index: number) => {
              if (item?.titleIcon === 'viewers') return null;
              if (!showNoDataMetricCard && calcIsEmptyOverviewCard(item)) return null;
              return (
                <Col key={index} span={8}>
                  <OverviewCard
                    key={`indicator${item.titleContent}`}
                    className={classnames({
                      [COMPETITOR_GUIDE_CLASSNAMES.ELEMENT4]: item?.metricUserGuide === 'digitalRevenue',
                    })}
                    titleContent={item.titleContent}
                    titleIcon={item.titleIcon}
                    baseIndicators={item.baseIndicators}
                    numArrowData={item.numArrowData}
                    lineData={item.lineData}
                    lineDom={item.lineDom}
                    rankData={item.rankData}
                    index={index}
                    moduleName={moduleName}
                    entityType={entityType}
                    rankLoading={rankLoading}
                    setActiveId={setActiveId}
                    conditionDate={streamingType}
                    conditionMarket={conditionMarket}
                    gameId={gameId}
                    // @ts-ignore
                    activeId={activeId}
                    cardItem={item}
                    setActiveSegment={setActiveSegment}
                    isOperateRegion={isOperateRegion}
                    isShowDataSourceIcon={false}
                    isShowRateTips={true}
                  />
                </Col>
              );
            })}
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};

export default StreamingContent;
